// NPM Modules
import Firebase from 'firebase';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyAdlW3vPAW24dzVmiAhwSZ2xr1C8E14uIs",
  authDomain: "recipedia-e233f.firebaseapp.com",
  databaseURL: "https://recipedia-e233f.firebaseio.com",
  storageBucket: "recipedia-e233f.appspot.com",
  messagingSenderId: "601670081718"
};

var FirebaseApp = Firebase.initializeApp(config);

export default FirebaseApp;



// WEBPACK FOOTER //
// ./src/modules/FirebaseApp.js